import { FC } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { Grid, useTheme } from '@mui/material'
import { useHistoricalStatisticsStore } from '@/stores/historicalStatistics'

import {
  EventStreams,
  PlatformPopularity,
  RegionCard,
  SportPopularity,
  StatisticsSummary,
  TopOperators,
  TotalViews
} from '../cards'
import { StatisticsPanelGridRow } from './StatisticsPanelGridRow'

type StatisticsPanelProps = {
  printRef?: React.RefObject<HTMLDivElement | null>
}

export const StatisticsPanel: FC<StatisticsPanelProps> = ({ printRef }) => {
  const theme = useTheme()
  const isH2H = useHistoricalStatisticsStore(useShallow((state) => state.isH2H))

  return (
    <Grid
      ref={printRef}
      container
      m={2}
      pt={0}
      mr={2}
      columns={isH2H ? 12 : 6}
      columnSpacing={2}
      sx={{
        borderRadius: Number(theme.shape.borderRadius) / 2
      }}
    >
      <StatisticsPanelGridRow
        component={StatisticsSummary}
        GridProps={{
          p: 0,
          sx: {
            backgroundColor: undefined
          }
        }}
      />
      <StatisticsPanelGridRow component={TotalViews} />
      <StatisticsPanelGridRow component={SportPopularity} />
      <StatisticsPanelGridRow component={PlatformPopularity} />
      <StatisticsPanelGridRow component={TopOperators} />
      <StatisticsPanelGridRow component={EventStreams} />
      <StatisticsPanelGridRow
        component={RegionCard}
        GridProps={{
          pb: 2
        }}
      />
    </Grid>
  )
}
